import OLD_ERRORS from 'constants/messages/oldErrors.const';
import logger from 'utils/logger.util';

const L = logger('fromAnyToMessageV1');

const UNKNOWN = OLD_ERRORS.Unknown;
const EXTRA = OLD_ERRORS.UnknownExtra;

const fromAnyToMessageV1 = (key) => {
  if (OLD_ERRORS[key]) return OLD_ERRORS[key];
  L.warn('()', 'Untranslated key:', key);
  return `${UNKNOWN}${key ? EXTRA + key : '.'}`;
};

// noinspection JSUnusedGlobalSymbols
export default fromAnyToMessageV1;
